export default __webpack_public_path__ + "static/media/prize-3-bm.b7431f9b.webp";